import { Timestamp } from '@weblite/ts-action'
import { LocalFind, LocalInsert } from '@weblite/persist'
import { RELEASE_TIME, VERSION } from '$setup/version'
import {
  createKeyvalStorage,
  createKeyvalView,
} from '$logic/lib/keyval.storage'

interface ReleaseInfo {
  releaseTime: number
  version: string
}

const APP_RELEASE = 'appRelease'
export function saveReleaseVersion(releaseTime: Timestamp, version: string) {
  LocalInsert(APP_RELEASE, { releaseTime, version })
}

export function getCurrentRelease(): ReleaseInfo {
  const localRelease = LocalFind(APP_RELEASE)
  if (!localRelease) saveReleaseVersion(RELEASE_TIME, VERSION)
  const release = localRelease || LocalFind(APP_RELEASE)
  release.releaseTime = new Date(release.releaseTime).getTime()
  return release
}

interface ClientSettings {
  autoDownload: boolean
  autoPlayAudio: boolean
  autoSyncContacts: boolean
  recentUsers: boolean
}

const CLIENT_SETTINGS = 'clientSettings'
export const clientSettingsStorage =
  createKeyvalStorage<ClientSettings>(CLIENT_SETTINGS)
export const clientSettingsView =
  createKeyvalView<ClientSettings>(CLIENT_SETTINGS)
